import { render, staticRenderFns } from "./VideoInfo.vue?vue&type=template&id=07f3307d"
import script from "./VideoInfo.vue?vue&type=script&lang=ts"
export * from "./VideoInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports